import { subscriptionConstants as sc } from 'srcReact/SubscriptionPage'
import { subscriptionService } from 'srcReact/services'
import { isEmpty } from 'srcReact/helpers/validator'
import { alertActions } from 'srcReact/Alert'

export const subscriptionActions = {
  // create,
  updateAfterCheckout,
  createAfterCheckout,
  redirectToSubscriptionCheckout,
  //update,
  getPlanUpdateList,
  updatePlan,
  updatePlanSimple,
  cancelPendingPlanUpdate,
  getCurrency
}

function redirectToSubscriptionCheckout(organizationId, planId) {
  return (dispatch) => {
    dispatch(request({ organizationId, planId }))

    subscriptionService.getSubscriptionHostedUrl(organizationId, planId).then(
      (response) => {
        dispatch(success(response))
        if (!isEmpty(response.hosted_page)) {
          window.location = response.hosted_page.url
        } else {
          dispatch(failure(error))
        }
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: sc.CREATE_SUBSCRIPTION_AFTER_CHECKOUT_REQUEST, response }
  }
  function success(response) {
    return { type: sc.CREATE_SUBSCRIPTION_AFTER_CHECKOUT_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.CREATE_SUBSCRIPTION_AFTER_CHECKOUT_FAILURE, error }
  }
}

// function create(organizationId, subscriptionId, planId, state) {
//   return (dispatch) => {
//     dispatch(request({ organizationId, subscriptionId, planId, state }))

//     subscriptionService.create(organizationId, subscriptionId, planId, state).then(
//       (response) => {
//         dispatch(success(response))
//       },
//       (error) => {
//         dispatch(failure(error))
//       }
//     )
//   }

//   function request(response) {
//     return { type: sc.CREATE_SUBSCRIPTION_REQUEST, response }
//   }
//   function success(response) {
//     return { type: sc.CREATE_SUBSCRIPTION_SUCCESS, response }
//   }
//   function failure(error) {
//     return { type: sc.CREATE_SUBSCRIPTION_FAILURE, error }
//   }
// }

function createAfterCheckout(organizationId, hostedPageId, state) {
  return (dispatch) => {
    dispatch(request({ organizationId, hostedPageId, state }))

    subscriptionService.createAfterCheckout(organizationId, hostedPageId, state).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(alertActions.error(error))
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: sc.CREATE_SUBSCRIPTION_AFTER_CHECKOUT_REQUEST, response }
  }
  function success(response) {
    return { type: sc.CREATE_SUBSCRIPTION_AFTER_CHECKOUT_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.CREATE_SUBSCRIPTION_AFTER_CHECKOUT_FAILURE, error }
  }
}

function updateAfterCheckout(organizationId, hostedPageId, state, subscriptionId, new_plan) {
  return (dispatch) => {
    dispatch(request({ organizationId, hostedPageId, state, subscriptionId, new_plan }))

    subscriptionService.updateAfterCheckout(organizationId, hostedPageId, state, subscriptionId, new_plan).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: sc.UPDATE_SUBSCRIPTION_AFTER_CHECKOUT_REQUEST, response }
  }
  function success(response) {
    return { type: sc.UPDATE_SUBSCRIPTION_AFTER_CHECKOUT_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.UPDATE_SUBSCRIPTION_AFTER_CHECKOUT_FAILURE, error }
  }
}

// function update(organizationId, planId) {
//   return (dispatch) => {
//     dispatch(request({ organizationId, planId }))

//     subscriptionService.update(organizationId, planId).then(
//       (response) => {
//         dispatch(success(response))
//       },
//       (error) => {
//         dispatch(failure(error))
//       }
//     )
//   }

//   function request(response) {
//     return { type: sc.UPDATE_SUBSCRIPTION_REQUEST, response }
//   }
//   function success(response) {
//     return { type: sc.UPDATE_SUBSCRIPTION_SUCCESS, response }
//   }
//   function failure(error) {
//     return { type: sc.UPDATE_SUBSCRIPTION_FAILURE, error }
//   }
// }

function getPlanUpdateList(organizationId) {
  return (dispatch) => {
    dispatch(request({ organizationId }))

    subscriptionService.getPlanUpdateList(organizationId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: sc.GET_PLAN_UPDATE_LIST_REQUEST, response }
  }
  function success(response) {
    return { type: sc.GET_PLAN_UPDATE_LIST_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.GET_PLAN_UPDATE_LIST_FAILURE, error }
  }
}

function updatePlan(organizationId, planId) {
  return (dispatch) => {
    dispatch(request({ organizationId, planId }))

    subscriptionService.updatePlan(organizationId, planId).then(
      (responseUpdatePlan) => {
        subscriptionService.getPlanUpdateList(organizationId).then(
          (responsePlanUpdateList) => {
            subscriptionService.getSubscription(organizationId, 0).then(
              (responseSubscription) => {
                dispatch(success({ responsePlanUpdateList, responseSubscription, responseUpdatePlan }))
              },
              (error) => {
                window.location.reload()
              }
            )
          },
          (error) => {
            dispatch(failure(error))
          }
        )
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: sc.UPDATE_PLAN_REQUEST, response }
  }
  function success(response) {
    return { type: sc.UPDATE_PLAN_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.UPDATE_PLAN_FAILURE, error }
  }
}

function updatePlanSimple(organizationId, planId) {
  return (dispatch) => {
    dispatch(request({ organizationId, planId }))

    subscriptionService.updatePlan(organizationId, planId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: sc.UPDATE_PLAN_SIMPLE_REQUEST, response }
  }
  function success(response) {
    return { type: sc.UPDATE_PLAN_SIMPLE_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.UPDATE_PLAN_SIMPLE_FAILURE, error }
  }
}

function cancelPendingPlanUpdate(organizationId) {
  return (dispatch) => {
    dispatch(request({ organizationId }))

    subscriptionService.cancelPendingPlanUpdate(organizationId).then(
      (response) => {
        dispatch(success(response))
        window.location.reload()
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: sc.CANCEL_PENDING_PLAN_UPDATE_REQUEST, response }
  }
  function success(response) {
    return { type: sc.CANCEL_PENDING_PLAN_UPDATE_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.CANCEL_PENDING_PLAN_UPDATE_FAILURE, error }
  }
}

function getCurrency(organizationId, longitude, latitude, language) {
  return (dispatch) => {
    dispatch(request({ organizationId, longitude, latitude, language }))

    subscriptionService.getCurrency(organizationId, longitude, latitude, language).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: sc.GET_CURRENCY_REQUEST, response }
  }
  function success(response) {
    return { type: sc.GET_CURRENCY_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.GET_CURRENCY_FAILURE, error }
  }
}
